import Translate from './containers/Translate';

export default Translate;
